// dibs-css must be imported before any packages that import dibs-css to guarantee dibs-css is
// bundled correctly in DAL.
import 'dibs-css/exports/dibs-css.module.css';

import { createRoot } from 'react-dom/client';
import { QueryRenderer, graphql } from 'react-relay/legacy';
import { IntlProvider } from 'dibs-react-intl';
import serverVars from 'server-vars';
import contextFactory, { type RenderNavbar } from './navBarContextFactory';
import { NavContextProvider } from './NavContext';

import { type dealerQuery } from './__generated__/dealerQuery.graphql';

import '../common';
import '../../scss/entries/dealers.scss';
import { getSellerQueryVariables } from '../../../exports/getSellerQueryVariables';
import { SellerNav } from './components/Nav/SellerNav';

const navDomElement = document.getElementById('navigation');

if (navDomElement) {
    const root = createRoot(navDomElement as HTMLElement);

    const renderNavbar: RenderNavbar = context => {
        const variables = getSellerQueryVariables();

        return root.render(
            <IntlProvider locale={serverVars.get('locale')} messages={serverVars.get('messages')}>
                <NavContextProvider>
                    <QueryRenderer<dealerQuery>
                        query={graphql`
                            query dealerQuery(
                                $sellerPk: String = ""
                                $userId: String = ""
                                $dotComHost: String!
                                $hyperwalletLink: String!
                                $customBannerText: String = ""
                                $hasSellerPk: Boolean!
                            ) {
                                viewer {
                                    ...SellerNav_viewer
                                }
                            }
                        `}
                        variables={variables}
                        environment={context.relayEnvironment}
                        render={({ props }) => {
                            const viewer = props?.viewer;
                            if (!viewer) {
                                return null;
                            }
                            return <SellerNav viewer={viewer} />;
                        }}
                    />
                </NavContextProvider>
            </IntlProvider>
        );
    };

    window.navbarContext = contextFactory(renderNavbar);
    renderNavbar(window.navbarContext());
}
